import { FACILITY_ENDPOINT } from '../config/constants'
import { authorizeHeader } from '../utils/auth-header'
import { v4 as uuidV4 } from 'uuid'

export const postCreateFacilityAPICall = async ({ userFacilityAddress, userFacilityCity, userFacilityCountry, userFacilityEmail, userFacilityName, userFacilityPhone, userFacilityType, userFacilityLogo, containerURL, userMemberOf, hideProgress }) => {
  try {

    let logo = ''

    const userSinglePhone = (userFacilityPhone && userFacilityPhone.phone)
    const guid = uuidV4()
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ location: userFacilityAddress, city: userFacilityCity, guid: guid, country: userFacilityCountry, email: userFacilityEmail, facility_type: userFacilityType, name: userFacilityName, facility_logo: logo, contact_number_1: userSinglePhone, member_of: userMemberOf })
    }
    const response = await window.fetch(FACILITY_ENDPOINT, authorizeHeader(config))
    const responseOk = await response.status === 201
    const responseJSON = await response.json()
    return { responseOk, responseJSON }
  } catch (e) {
    console.error('ERROR: ', e)
    return e
  }
}

